import { useAuthenticatedSubmit } from '@/modules/submissions/presentation/hooks/use-authenticated-submit';

/**
 * O envio do gabarito. Sem sessão, o diálogo começa em **"Você já tem
 * conta?"** — sim leva ao login, não ao cadastro.
 *
 * A pergunta vem antes de qualquer formulário porque quem volta dias depois do
 * ensaio já tem conta, e quem nunca fez o ensaio não tem: cair direto no
 * cadastro (ou no login) erraria metade das pessoas.
 */
export function useFinishGabarito(onDone: () => void) {
  return useAuthenticatedSubmit({
    kind: 'gabarito',
    reason: 'gabarito',
    firstView: { kind: 'ask' },
    onDone,
  });
}
